import script from "./PaymentStatusView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStatusView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStatusView.vue?vue&type=style&index=0&id=0f84c20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f84c20c"]])

export default __exports__